var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80312 1.64768C8.06567 1.38513 8.06567 0.959457 7.80312 0.69691C7.54057 0.434363 7.1149 0.434364 6.85235 0.696911L3.99982 3.54944L1.14768 0.69729C0.885129 0.434743 0.459457 0.434743 0.19691 0.69729C-0.0656372 0.959837 -0.0656363 1.38551 0.196911 1.64806L3.04906 4.50021L0.19699 7.35227C-0.0655567 7.61482 -0.0655567 8.04049 0.19699 8.30304C0.459537 8.56559 0.88521 8.56558 1.14776 8.30304L3.99982 5.45097L6.85227 8.30342C7.11482 8.56597 7.54049 8.56597 7.80304 8.30342C8.06559 8.04087 8.06559 7.6152 7.80304 7.35265L4.95059 4.5002L7.80312 1.64768Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGray);
export default __webpack_public_path__ + "static/media/close-icon-gray.07c9aeab.svg";
export { ForwardRef as ReactComponent };